"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
function default_1(inputId, event) {
    const { isNativeApp, isNativeAppPhotoGranted } = window;
    if (isNativeApp && !isNativeAppPhotoGranted) {
        event.preventDefault();
        (0, _1.postMessageToWVA)(`PHOTO::${inputId}`);
    }
}
exports.default = default_1;
